import { Injectable } from '@angular/core';
import {
  CanActivateChild,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Resolve,
} from '@angular/router';
import { Observable } from 'rxjs';
import { CalculatorService } from 'src/app/services/calculator/calculator.service';

@Injectable()
export class CalculatorGuard implements Resolve<any> {
  constructor(public calculator: CalculatorService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.calculator.HasReady;
  }
}
